module.exports = __webpack_public_path__ + "img/banner.94d3cef5.png";